export const LEGAL_NAMESPACE = "legal";
